import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { HeaderProps } from "./Header.types";
import { Div, Paragraph } from "../../basic";

export const Header = ({ left, right, center, statusBarColor }: HeaderProps) => {
  const insets = useSafeAreaInsets();
  return (
    <Div classNames={["w100", ...(Platform.OS == "web" ? ["fixed", "w100abs", "zIndex1000"] : [])]}>
      {statusBarColor ? <Div classNames={[`h-{${insets.top}}`, `bgColor-{${statusBarColor}}`]}></Div> : null}
      <Div
        classNames={[
          "dFlex",
          "flexRow",
          "alignItemsCenter",
          "justifyContentSpaceBetween",
          "relative",
          "ph8",
          `pt-{${statusBarColor ? 4 : insets.top + 4}}`,
          `pb-{8}`,
          "bgSecondaryMain",
          "bwBottom-{1}",
          "borderPrimary",
        ]}
      >
        <Div classNames={["flex-{0.33}", "dFlex"]}>
          {typeof left === "string" ? <Paragraph classNames={["b1Bold"]}>{left}</Paragraph> : left}
        </Div>
        <Div classNames={["flex1", "dFlex", "flexRow", "justifyContentCenter"]}>
          {typeof center === "string" ? <Paragraph classNames={["b1Bold", "mb-{10}"]}>{center}</Paragraph> : center}
        </Div>
        <Div classNames={["flex-{0.33}", "dFlex", "flexRow", "justifyContentFlexEnd"]}>
          {typeof right === "string" ? <Paragraph classNames={["b1Bold", "textCenter"]}>{right}</Paragraph> : right}
        </Div>
      </Div>
    </Div>
  );
};
